import { Languages } from "lucide-react";
import { languageOptions, useI18n } from "../i18n";

export function LanguageSelect({ light = false }: { light?: boolean }) {
  const { language, setLanguage } = useI18n();
  return (
    <label className={`language-select${light ? " light" : ""}`}>
      <Languages size={17} aria-hidden="true" />
      <span className="sr-only">Language / Sprache / Idioma / Langue</span>
      <select value={language} onChange={(event) => setLanguage(event.target.value as typeof language)} aria-label="Language / Sprache / Idioma / Langue">
        {languageOptions.map((option) => <option key={option.value} value={option.value}>{option.short} · {option.label}</option>)}
      </select>
    </label>
  );
}
